export default __webpack_public_path__ + "static/media/story_otomo-9.f6fd2985.png";